angular.module 'app'
.controller 'AddTemplateCtrl', ($scope, $http, $stateParams, $state, config, Storage, dialogs, growl, SweetAlert) ->
